import { Button, Typography } from "@bca/ui-library";

const ToggleVisibleFiltersButton = ({ onClick, text }) => {
  return (
    <Button variant="tertiary" p={0} onClick={onClick} height="auto">
      <Typography
        color="primary-light-blue"
        variant="body"
        my={0}
        css={`
          text-decoration: underline;
        `}
      >
        {text}
      </Typography>
    </Button>
  );
};

export default ToggleVisibleFiltersButton;
